import * as L from 'leaflet';
import { TIME_PLAYBACK_TICKED, TIME_PLAYBACK_ENDED, TIME_PLAYBACK_PAUSED, TIME_PLAYBACK_STARTED_RESUMED, TIME_CHANGED, } from '../events';
/**
 * The time management.
 */
export class ManagementTime extends L.Evented {
    /**
     * Create a new time management instance.
     * @param timesteps - ordered list of datetime objects
     * @param initialIndex - index in `timesteps` to be selected initially
     * @param maapInstance - The M.A.A.P. instance.
     * @param options - The time management options.
     */
    constructor(timesteps, initialIndex, maapInstance, options) {
        super();
        /**
         * The time management options.
         */
        this.options = {
            tickDelay: 500,
            nowDelay: 1000,
            shouldLoop: false,
        };
        /**
         * The interval between the ticks in autoplay mode.
         */
        this.tickInterval = null;
        /**
         * Whether the map is in playback mode.
         */
        this.isPlaying = false;
        this.timesteps = timesteps;
        this.timestepsPointer = initialIndex;
        this.maapInstance = maapInstance;
        this.options = Object.assign(Object.assign({}, this.options), options);
        this.addEventParent(maapInstance);
    }
    currentTime() {
        return this.timesteps[this.timestepsPointer];
    }
    getTimesteps() {
        return this.timesteps;
    }
    /**
     * Move a tick on the timeslider.
     * @fires TIME_PLAYBACK_TICKED
     * @fires TIME_PLAYBACK_ENDED
     * @param isFirstTick - Whether it's the first tick of a play sequence.
     */
    iterate(isFirstTick = false) {
        if (this.timestepsPointer == this.timesteps.length - 1) {
            if (this.options.shouldLoop) {
                // start loop again...
                this.timestepsPointer = 0;
                this.fire(TIME_PLAYBACK_TICKED, {}, true);
            }
            else {
                // stop the animation
                if (this.tickInterval !== null) {
                    clearInterval(this.tickInterval);
                    this.tickInterval = null;
                }
                this.isPlaying = false;
                this.timestepsPointer = 0;
                this.fire(TIME_PLAYBACK_TICKED, {}, true);
                if (!isFirstTick)
                    this.fire(TIME_PLAYBACK_ENDED, {}, true);
            }
        }
        else {
            this.timestepsPointer++;
            this.fire(TIME_PLAYBACK_TICKED, {}, true);
        }
    }
    /**
     * Start the playback.
     * @fires TIME_PLAYBACK_STARTED_RESUMED
     */
    play() {
        if (this.isPlaying) {
            return;
        }
        setTimeout(() => {
            this.iterate(true);
        }, 0);
        this.tickInterval = window.setInterval(() => this.iterate(), this.options.tickDelay);
        this.isPlaying = true;
        this.fire(TIME_PLAYBACK_STARTED_RESUMED, {}, true);
    }
    /**
     * Pause the playback.
     * @fires TIME_PLAYBACK_PAUSED
     */
    pause() {
        if (!this.isPlaying) {
            return;
        }
        if (this.tickInterval !== null) {
            clearInterval(this.tickInterval);
            this.tickInterval = null;
        }
        this.isPlaying = false;
        this.fire(TIME_PLAYBACK_PAUSED, {}, true);
    }
    /**
     * Toggle the playback.
     */
    toggle() {
        if (this.isPlaying) {
            this.pause();
        }
        else {
            this.play();
        }
    }
    /**
     * Set the time using a timestamp.
     * @fires TIME_CHANGED
     * @param dt - The datetime to set.
     */
    setTime(dt) {
        const index = this.timesteps.findIndex((timestep) => dt.equals(timestep));
        if (index == -1) {
            throw new Error(`unknown time: ${dt.toISO()}`);
        }
        this.timestepsPointer = index;
        this.fire(TIME_CHANGED, {}, true);
    }
    /**
     * Removes the event parent and clears the intervals.
     */
    destroy() {
        this.removeEventParent(this.maapInstance);
        if (this.tickInterval) {
            clearInterval(this.tickInterval);
        }
    }
}
//# sourceMappingURL=ManagementTime.js.map